import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const ITEMS = 'items'

/**
 * Form model
 */
const formModel = () => {
  return {
    [ITEMS]: {
      label: `${t('common.students')}`,
      name: ITEMS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [ITEMS]: [],
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [ITEMS]: yup
      .array()
      .nullable()
  })

export default formModel
